module.exports = __webpack_public_path__ + "img/collaborate_45.c73c5d66.jpg";